// ─── Lo que se TECLEÓ en la línea de la orden es del documento, no del costo ─
// Una orden de compra nacida de costos se vuelve a armar cada vez que se
// guardan los costos de su OP: el costo manda sobre artículo, cantidad, precio
// e IVA. Pero el color, el logo, la impresión, la ubicación, la referencia y
// la descripción se escriben EN LA ORDEN —es lo que el proveedor necesita para
// marcar— y se reescribían en blanco con cada guardado. Pasó con OCI-0001
// (FUCSIA): se mandó con todo el detalle y al abrirla las líneas estaban
// peladas.
//
// La línea que ya existe se reconoce por el costo del que nació (`_ccid`,
// columna ocp_items.ccid); las anteriores a esa marca, por el artículo. Una
// línea que no se reconoce no se conserva: su costo ya no está en la orden.
export const DETALLE_LINEA_OCP = ["descripcion", "referencia", "color", "logo", "impresion", "ubicacion"];

export function conservarDetalleLineas(nuevas, previas) {
  const libres = [...(previas || [])];
  const tomar = (pred) => { const i = libres.findIndex(pred); return i < 0 ? null : libres.splice(i, 1)[0]; };
  return (nuevas || []).map(it => {
    const previa = (it._ccid && tomar(x => x._ccid === it._ccid))
      || tomar(x => !x._ccid && x.articulo === it.articulo)
      || null;
    if (!previa) return it;
    const out = { ...it };
    DETALLE_LINEA_OCP.forEach(k => { if (previa[k]) out[k] = previa[k]; });
    return out;
  });
}
